// Le texte d'aide du jour survolé vit hors de l'état de la page : survoler un jour ne redessine que cette ligne, pas le calendrier, le panneau et la fenêtre.
import { useRef, useSyncExternalStore } from 'react';

export interface Survol {
  lire: () => string | null;
  ecrire: (texte: string | null) => void;
  abonner: (f: () => void) => () => void;
}

export function creerSurvol(): Survol {
  let texte: string | null = null;
  const abonnes = new Set<() => void>();
  return {
    lire: () => texte,
    ecrire: (t) => { if (t === texte) return; texte = t; abonnes.forEach((f) => f()); },
    abonner: (f) => { abonnes.add(f); return () => { abonnes.delete(f); }; },
  };
}

/** Un « survol » par page (le même à chaque rendu). */
export function useSurvol(): Survol {
  const r = useRef<Survol | null>(null);
  if (!r.current) r.current = creerSurvol();
  return r.current;
}

/** Le texte survolé, ou null (la ligne d'aide revient alors à son message). Seul le composant qui l'appelle se redessine. */
export function useTexteSurvole(s: Survol): string | null {
  return useSyncExternalStore(s.abonner, s.lire);
}
